// extracted by mini-css-extract-plugin
var _1 = "ReportCrumbs__block--ysplr ReportCrumbs__dropdown--N_DNd";
var _2 = "ReportCrumbs__chapter--SmSli ReportCrumbs__dropdown--N_DNd";
var _3 = "ReportCrumbs__dropdown--N_DNd";
var _4 = "ReportCrumbs__grade--pwSKF ReportCrumbs__dropdown--N_DNd";
var _5 = "ReportCrumbs__hideable--_RR9C";
var _6 = "ReportCrumbs__link--Ng47R";
var _7 = "ReportCrumbs__main--fp2Lw";
var _8 = "ReportCrumbs__textOnly--V5qEr";
export { _1 as "block", _2 as "chapter", _3 as "dropdown", _4 as "grade", _5 as "hideable", _6 as "link", _7 as "main", _8 as "textOnly" }
